import React, { useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useState, useRef } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { List, ListItem, ListItemText, Divider, Grid, TextField } from '@mui/material';
import HeightBox from '../components/HeightBox';
import { Document, Page, pdfjs } from 'react-pdf';
import { styled, useTheme } from '@mui/material/styles'
import { useSelector, useDispatch } from 'react-redux';
import FileList from './fileList.';
import CandidateService from '../../../services/candidateService';

// import './AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import "react-pdf/dist/esm/Page/TextLayer.css";
import { setSelectedURLs } from '../../../actions/fileActions';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import PageViewer from './pageViewer';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import './styles.css'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;



const printTheme = createTheme({
  // Add styles specific to the print.js file
});


const UserProfileContainer = (formValues) => {

  const theme = useTheme();

  const Root = styled('div')({
    flexGrow: 1,
    margin: 'auto',
    // padding: '2rem',
  });

  const Header = styled('div')({
    marginBottom: '1rem',
  });

  const SectionHeader = styled('div')({
    marginTop: '2rem',
    marginBottom: '1rem',
  });

  const ListItemTextStyle = styled('div')({
    margin: '0',
  });

  const TextContent = styled('div')({
    display: 'none',
  });

  // Store
  const selectedURLs = useSelector((state) => state.file.selectedURLs);
  const passportSizeImageURL = useSelector((state) => state.file.selectedPassportSizePhoto);
  // Dummy data for the table
  const [cvData, setCvData] = React.useState(formValues.data);
  const [passportSizeImage, setPassportSizeImage] = useState(null);
  const [passportSizeImagePreview, setPassportSizeImagePreview] = useState('');
  const [certificatePdfPreview, setCertificatePdfPreview] = useState('');

  const [selectedFile, setSelectedFile] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [jpgImages, setJpgImages] = useState([]); // array of base64 strings
  const [whatsappContactView, setWhatsappContactView] = useState(formValues?.data?.properties?.whatsappContactView)
  const [emergencyContactView, setEmergencyContactView] = useState(formValues?.data?.properties?.emergencyContactView)

  // profile data view and hide
  const [headerOn, setHeaderOn] = useState(formValues?.data?.properties?.headerOn);
  const [showProfessionalMemberships, setShowProfessionalMemberships] = useState(formValues?.data?.properties?.showProfessionalMemberships);
  const [showProfessionalQualifications, setShowProfessionalQualifications] = useState(formValues?.data?.properties?.showProfessionalQualifications);
  const [showHigherEducationalQualifications, setShowHigherEducationalQualifications] = useState(formValues?.data?.properties?.showHigherEducationalQualifications);
  const [showItLiteracy, setShowItLiteracy] = useState(formValues?.data?.properties?.showItLiteracy);
  const [showHardSkills, setShowHardSkills] = useState(formValues?.data?.properties?.showHardSkills);
  const [boxHeightCareer, setBoxHeightCareer] = useState(formValues?.data?.properties?.boxHeightCareer);
  const [boxHeightBeforeCareer, setBoxHeightBeforeCareer] = useState(formValues?.data?.properties?.boxHeightBeforeCareer);
  const [boxBeforeSkills, setBoxBeforeSkills] = useState(formValues?.data?.properties?.boxBeforeSkills);
  const [boxAfterSkills, setBoxAfterSkills] = useState(formValues?.data?.properties?.boxAfterSkills);
  const [boxHeightBeforeWorkExperience, setBoxHeightBeforeWorkExperience] = useState(formValues?.data?.properties?.boxHeightBeforeWorkExperience);
  const [workExperienceBreak, setWorkExperienceBreak] = useState(formValues?.data?.properties?.workExperienceBreak);
  const [showDrivingLicense, setShowDrivingLicense] = useState(formValues?.data?.properties?.showDrivingLicense);
  const [showEducationalQualifications, setShowEducationalQualifications] = useState(formValues?.data?.properties?.showEducationalQualifications);

  const [properties, setProperties] = useState({
    headerOn: headerOn,
    whatsappContactView: whatsappContactView,
    emergencyContactView: emergencyContactView,
    showProfessionalMemberships: showProfessionalMemberships,
    showProfessionalQualifications: showProfessionalQualifications,
    showHigherEducationalQualifications: showHigherEducationalQualifications,
    showItLiteracy: showItLiteracy,
    showHardSkills: showHardSkills,
    boxHeightCareer: boxHeightCareer,
    boxHeightBeforeCareer: boxHeightBeforeCareer,
    boxBeforeSkills: boxBeforeSkills,
    boxAfterSkills: boxAfterSkills,
    boxHeightBeforeWorkExperience: boxHeightBeforeWorkExperience,
    workExperienceBreak: workExperienceBreak,
    showDrivingLicense: showDrivingLicense,
    showEducationalQualifications: showEducationalQualifications,
  })

  useEffect(() => {
    setProperties({
      headerOn,
      whatsappContactView,
      emergencyContactView,
      showProfessionalMemberships,
      showProfessionalQualifications,
      showHigherEducationalQualifications,
      showItLiteracy,
      showHardSkills,
      boxHeightCareer,
      boxHeightBeforeCareer,
      boxBeforeSkills,
      boxAfterSkills,
      boxHeightBeforeWorkExperience,
      workExperienceBreak,
      showDrivingLicense,
      showEducationalQualifications,
    });
  }, [
    headerOn,
    whatsappContactView,
    emergencyContactView,
    showProfessionalMemberships,
    showProfessionalQualifications,
    showHigherEducationalQualifications,
    showItLiteracy,
    showHardSkills,
    boxHeightCareer,
    boxHeightBeforeCareer,
    boxBeforeSkills,
    boxAfterSkills,
    boxHeightBeforeWorkExperience,
    workExperienceBreak,
    showDrivingLicense,
    showEducationalQualifications,
  ]);


  const dispatch = useDispatch();

  useEffect(() => {
    setCvData(formValues.data);
    console.log(cvData)
    console.log(passportSizeImageURL)
    setPassportSizeImagePreview(cvData.images.passportSize);
    setCertificatePdfPreview(cvData.profileAttached);
    setSelectedFile({ url: cvData.profileAttached });
  }, [formValues]);

  useEffect(() => {
    console.log("---------------")
    console.log(cvData.properties)

  }, [cvData]);





  // const classes = useStyles();
  const componentRef = useRef();

  const handlePrint = () => {
    CandidateService.updateProperties(cvData.id, cvData.regNumber, properties).then((response) => {
      console.log(response);
    }
    )
    handlePrintNow();
  }

  const handlePrintNow = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePassportSizeImageChange = (event) => {
    const file = event.target.files[0];
    setPassportSizeImage(file);
    setPassportSizeImagePreview(URL.createObjectURL(file));
  };

  const sendData = async () => {
    console.log(selectedURLs)
    const formData = new FormData();
    formData.append('passportImage', passportSizeImage);
    formData.append('certificatePdf', selectedFile);
    formData.append('data', JSON.stringify(cvData));

    try {
      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch('https://oseas-api.hypen.lk/api/v1/candidates', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        // Request successful
        const data = await response.json();
        alert('Data saved successfully');
        // Process the response data
      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };



  // useEffect(() => {
  //   CandidateService.updateProperties(cvData.id,cvData.regNumber,properties).then((response) => {
  //     console.log(response);
  //     }
  //   )
  // }, [properties]);


  const [numPagesMap, setNumPagesMap] = useState({});
  const [showIt, setShowIt] = useState(false);

  const onDocumentLoadSuccess = (file, { numPages }) => {
    setNumPagesMap(prevState => ({
      ...prevState,
      [file]: numPages
    }));
  };

  const [containerWidth, setContainerWidth] = useState(null);


  React.useEffect(() => {
    if (componentRef.current) {
      const width = componentRef.current.offsetWidth;
      setContainerWidth(width);
    }
  }, []);

  const convertToJpg = () => {
    if (selectedFile) {
      const jpgPromises = Array.from({ length: numPages }, (_, index) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        return new Promise((resolve) => {
          const image = new Image();
          image.src = canvas.toDataURL('image/jpeg');
          console.log(image.src)
          image.onload = () => {
            context.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = image.width;
            canvas.height = image.height;
            context.drawImage(image, 0, 0);

            canvas.toBlob((blob) => {
              resolve(blob);
            }, 'image/jpeg');
          };
        });
      });

      Promise.all(jpgPromises)
        .then((jpgBlobs) => {
          const jpgUrls = jpgBlobs.map((blob) => URL.createObjectURL(blob));
          console.log(jpgUrls);
          setJpgImages(jpgUrls);
        })
        .catch((error) => {
          console.error('Error converting to JPG:', error);
        });
    }
  };


  function formatDateOfBirth(dob) {
    try {
      const date = new Date(dob);
      const day = date.getDate();
      const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
      const year = date.getFullYear();

      const suffix = getOrdinalSuffix(day);

      return (
        <Typography component="div">
          {day}
          <Typography
            component="span"
            style={{
              position: 'relative',
              top: '-0.7em',
              left: '-0.3em',
              fontSize: '0.6em',
            }}
          >
            {" " + suffix}
          </Typography>{' '}
          {month} {year}
        </Typography>
      );
    } catch (e) {
      return dob;
    }
  }

  function getOrdinalSuffix(day) {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const relevantDigits = (day < 30) ? day % 20 : day % 30;
    const suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
    return suffix;
  }

  const [contentHeight, setContentHeight] = useState(0);
  const a4SheetHeight = 842; // Height of A4 sheet in pixels
  const lineHeight = 10; // Height of the horizontal line in pixels

  useEffect(() => {
    function handleResize() {
      setContentHeight(componentRef.current.offsetHeight);
    }

    // Call handleResize when the component mounts and on window resize
    handleResize();
    window.addEventListener('resize', handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const renderHorizontalLines = () => {
    const linesCount = Math.floor(contentHeight / a4SheetHeight);
    const lines = [];

    for (let i = 0; i < linesCount; i++) {
      // lines.push(<hr key={i} className="hr-line" style={{marginTop:'842px',top:0}} />);
    }

    return lines;
  };

  const [boxHeight, setBoxHeight] = useState(0);

  const handleHeightChange = (event) => {
    setBoxHeight(event.target.value);
  };


  const handleHeightChangeAc = (event) => {
    setBoxHeightCareer(event.target.value);
  };

  const handleHeightChangeBeforeCareer = (event) => {
    setBoxHeightBeforeCareer(event.target.value);
  };

  const handleHeightChangeBoxBeforeSkills = (event) => {
    setBoxBeforeSkills(event.target.value);
  };

  const handleHeightChangeBoxAfterSkills = (event) => {
    setBoxAfterSkills(event.target.value);
  };

  const handleHeightChangeBeforeWorkExperience = (event) => {
    setBoxHeightBeforeWorkExperience(event.target.value);
  };

  const [boxAfterHigherEducationHeight, setBoxAfterHigherEducationHeight] = useState(0);
  const handleHeightChangeAfterHigherEducation = (event) => {
    setBoxAfterHigherEducationHeight(event.target.value);
  };

  useEffect(() => {
    console.log(workExperienceBreak ? 'avoid' : 'auto')
  }, [workExperienceBreak])

  return (
    <ThemeProvider theme={printTheme}>
      <>

        <style>{`
        .annotationLayer .annotationTextContent {
          display: none !important;
        }
        .annotationLayer {
          display: none !important;
          height: 0 !important;
        }
      `}</style>
        <style type="text/css" media="print">
          {"\
          @page { size: portrait;   border: 2px solid black; margin: 20px          }\
        "}
        </style>
        <Grid container spacing={2} style={{ padding: '10px', marginTop: '20px' }}>
          <div
            style={{
              position: 'fixed',
              bottom: '1px',
              right: '20px',
              transform: "scale(0.8)",
              transformOrigin: 'bottom right', // Adjusted to set the origin at the bottom right corner
              backgroundColor: '#fff',
              padding: '10px',
              boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
              zIndex: 999,
            }}
          >
            <input
              type="checkbox"
              checked={headerOn}
              onChange={() => setHeaderOn(!headerOn)}
            />
            <label>Company Header</label>

            <input
              type="checkbox"
              checked={emergencyContactView}
              onChange={() => setEmergencyContactView(!emergencyContactView)}
            />
            <label>Emergency Contact</label>

            <input
              type="checkbox"
              checked={whatsappContactView}
              onChange={() => setWhatsappContactView(!whatsappContactView)}
            />

            <label>WhatsApp Contact</label>

            <input
              type="checkbox"
              checked={showProfessionalMemberships}
              onChange={() => setShowProfessionalMemberships(!showProfessionalMemberships)}
            />

            <label>Memberships</label>

            <input
              type="checkbox"
              checked={showProfessionalQualifications}
              onChange={() => setShowProfessionalQualifications(!showProfessionalQualifications)}
            />

            <label>Professional Qualification</label>

            <input
              type="checkbox"
              checked={showHigherEducationalQualifications}
              onChange={() => setShowHigherEducationalQualifications(!showHigherEducationalQualifications)}
            />

            <label>Higher Educational Qualification</label>
            <br></br>
            <input
              type="checkbox"
              checked={workExperienceBreak}
              onChange={() => setWorkExperienceBreak(!workExperienceBreak)}
            />
            <label>Work Experience Break</label>

            <input
              type="checkbox"
              checked={showDrivingLicense}
              onChange={() => setShowDrivingLicense(!showDrivingLicense)}
            />
            <label>Driving License</label>

            <input
              type="checkbox"
              checked={showItLiteracy}
              onChange={() => setShowItLiteracy(!showItLiteracy)}
            />
            <label>IT Literacy</label>

            <input
              type="checkbox"
              checked={showHardSkills}
              onChange={() => setShowHardSkills(!showHardSkills)}
            />
            <label>Hard Skills</label>

            <input
              type="checkbox"
              checked={showEducationalQualifications}
              onChange={() => setShowEducationalQualifications(!showEducationalQualifications)}
            />

            <label>Educational Qualifications</label>
            <br></br>
            <TextField
              size="small"
              label="Before Career Summary"
              type="number"
              value={boxHeightBeforeCareer}
              onChange={handleHeightChangeBeforeCareer}
              variant="outlined"
              margin="normal"
            />
            <TextField
              size="small"
              label="After Career Summary"
              type="number"
              value={boxHeightCareer}
              onChange={handleHeightChangeAc}
              variant="outlined"
              margin="normal"
            />
            <TextField
              size="small"
              label="After Higher Education"
              type="number"
              value={boxAfterHigherEducationHeight}
              onChange={handleHeightChangeAfterHigherEducation}
              variant="outlined"
              margin="normal"
            />
            <TextField
              size="small"
              label="Before Skills"
              type="number"
              value={boxBeforeSkills}
              onChange={handleHeightChangeBoxBeforeSkills}
              variant="outlined"
              margin="normal"
            />
            <TextField
              size="small"
              label="after Skills"
              type="number"
              value={boxAfterSkills}
              onChange={handleHeightChangeBoxAfterSkills}
              variant="outlined"
              margin="normal"
            />

            <TextField
              size="small"
              label="Before Work Experience"
              type="number"
              value={boxHeightBeforeWorkExperience}
              onChange={handleHeightChangeBeforeWorkExperience}
              variant="outlined"
              margin="normal"
            />

            <br></br>
            <Button variant='contained' style={{ marginRight: '10px' }} onClick={handlePrint}>Print Profile</Button>

          </div>
        </Grid>
        <div ref={componentRef}>
          <table style={{ width: '1000px', maxWidth: '100%', borderCollapse: 'collapse', borderBottom: '1px solid red', borderTop: '1px solid red', borderLeft: '1px solid red', border: '1px solid red' }}>
            <thead>
              <Typography
                className="print-only"
                style={{ position: 'fixed', fontWeight: 520, fontSize: 100, top: '50%', left: '1px', opacity: 0.1, transform: 'rotate(320deg) scaleY(1.5)' }} variant='h1' gutterBottom>
                CONFIDENTIAL
              </Typography>

              <tr>
                {headerOn &&
                  <th colSpan={3}>
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      alignItems='right'
                      sx={{
                        backgroundColor: 'white',
                        padding: '10px',
                        opacity: 1,
                        // borderBottom: '1px solid red' // Added border property
                      }}
                    >
                      <Box>
                        <Typography variant='h5' gutterBottom>
                          <img src='/recruit-logo.png' alt='Company Logo' style={{ height: '110px' }} />
                        </Typography>
                        <Typography variant='subtitle1' gutterBottom>
                        </Typography>
                      </Box>
                      <Box display='flex' alignItems='right'>
                        <HeightBox height={20} />
                        {/* <img src='/images/log.png' alt='Company Logo' style={{ height: '50px', marginRight: '16px' }} /> */}
                        <Box textAlign='center' style={{ fontSize: '18px', color: '#17375e' }}>
                          <Typography gutterBottom fontSize={20} fontWeight='900'>
                            RECRUITS PLUS (PVT) LTD
                          </Typography>
                          <HeightBox height={10} />
                          <Typography style={{ fontSize: '14px' }} gutterBottom>
                            ADDRESS: RECRUITS PLUS (PVT) LTD., NO.462/D,2ND FLOOR,ARANGALA JUNCTION,<br />ATHURUGIYA ROAD,MALAMBE, SRI LANKA.
                          </Typography>
                          <Typography style={{ fontSize: '14px' }} gutterBottom>
                            HOTLINE: +94 11 286 0310 / +94 77 687 1847 / +94 77 757 0707
                          </Typography>
                          <Typography style={{ fontSize: '14px' }} gutterBottom>
                            EMAIL: cv@recruitsplus.org / malinda@recruitsplus.org
                          </Typography>
                          <Typography style={{ fontSize: '14px' }} gutterBottom>
                            WEBSITE: www.recruitsplus.org
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <Typography variant='h6' gutterBottom>
                          <img src='/test.png' alt='Company Logo' style={{ height: '110px', padding: '10px' }} />
                        </Typography>
                        <Typography variant='subtitle1' gutterBottom>
                        </Typography>
                      </Box>
                    </Box>
                  </th>
                }
                {!headerOn &&
                  <th colSpan={3}>
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      alignItems='right'
                      sx={{
                        backgroundColor: 'white',
                        padding: '10px',
                        opacity: 1,
                        // borderBottom: '1px solid red' // Added border property
                      }}
                    >
                      <Box>

                      </Box>
                      <Box display='flex' alignItems='right'>
                        <HeightBox height={20} />
                        {/* <img src='/images/log.png' alt='Company Logo' style={{ height: '50px', marginRight: '16px' }} /> */}
                        <Box textAlign='center' style={{ fontSize: '18px', color: '#17375e' }}>
                          <Typography gutterBottom fontSize={20} fontWeight='900'>
                            CANDIDATE PROFILE
                          </Typography>
                        </Box>

                      </Box>

                      <Box>
                      </Box>

                    </Box>
                  </th>
                }
              </tr>

            </thead>
            {/* Image and Name */}
            <tbody>
              <tr>
                <td>
                  <HeightBox height={5} />

                  <Box sx={{ fontSize: '15px', fontFamily: 'Arial, sans-serif' }}>
                    {/* <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        sx={{ backgroundColor: ' #17375e', color: 'white', padding: '10px', opacity: 1 }}
                      >
                        <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                         <strong>  PERSONAL INFORMATION </strong>
                        </Typography>
                      </Box> */}

                    <HeightBox height={10} />

                    <Grid container spacing={2}>
                      <Grid item xs={3}>
                        <Box marginRight={6}>
                          <img style={{ maxWidth: '150px', marginLeft: '12px' }} src={passportSizeImageURL} alt="Hi" />
                        </Box>
                      </Grid>
                      <Grid item xs={9}>
                        <Box>
                          <Grid container spacing={2}>
                            <Grid item xs={10}>
                              <Box padding={2}>
                                <Typography variant="h6" gutterBottom>
                                  <strong>NAME : {cvData?.fullName.toUpperCase()}</strong>
                                </Typography>
                                <HeightBox height={10} />
                                <Typography variant="h6" gutterBottom>
                                  <strong>APPLIED FOR : {cvData?.personalInfo?.appliedPosition?.toUpperCase()}</strong>
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={2}>

                            </Grid>


                          </Grid>
                        </Box>
                      </Grid>


                    </Grid>
                  </Box>
                </td>
              </tr>
            </tbody>
            {/* Personal Information */}

            <tbody>
              <tr>
                <td>
                  <HeightBox height={20} />

                  <Box sx={{ fontSize: '15px', fontFamily: 'Arial, sans-serif' }}>
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      alignItems='center'
                      sx={{ backgroundColor: ' #17375e', color: 'white', padding: '10px', opacity: 1 }}
                    >
                      <Typography style={{ fontSize: '15px', color: 'white' }} gutterBottom>
                        <strong>  PERSONAL INFORMATION </strong>
                      </Typography>
                    </Box>

                    <HeightBox height={10} />

                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Box>
                          <Grid container spacing={2}>
                            <Grid item xs={5}>
                              <Box padding={2}>
                                {/* <Typography variant="body1" gutterBottom>
                                        <strong>FULL NAME</strong>
                                      </Typography> */}
                                <Typography variant="body2" gutterBottom>
                                  <strong>DATE OF BIRTH</strong>
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  <strong>AGE</strong>
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  <strong>NATIONALITY</strong>
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  <strong>GENDER</strong>
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  <strong>CIVIL STATUS</strong>
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  <strong>AVAILABILITY</strong>
                                </Typography>
                                {showDrivingLicense &&
                                  <Typography variant="body2" gutterBottom>
                                    <strong>DRIVING LICENSE</strong>
                                  </Typography>
                                }
                                <Typography variant="body2" gutterBottom>
                                  <strong>PASSPORT</strong>
                                </Typography>
                                {whatsappContactView &&
                                  <Typography variant="body2" gutterBottom>
                                    <strong>CONTACT NO  </strong>
                                  </Typography>
                                }
                                {emergencyContactView &&
                                  <Typography variant="body2" gutterBottom>
                                    <strong>EMERGENCY CONTACT</strong>
                                  </Typography>
                                }
                              </Box>
                            </Grid>
                            <Grid item xs={1}>
                              <Box padding={2}>
                                <Typography variant="body2" gutterBottom>
                                  :
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  :
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  :
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  :
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  :
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                  :
                                </Typography>
                                {showDrivingLicense &&
                                  <Typography variant="body2" gutterBottom>
                                    :
                                  </Typography>
                                }
                                <Typography variant="body2" gutterBottom>
                                  :
                                </Typography>
                                {whatsappContactView &&
                                  <Typography variant="body2" gutterBottom>
                                    :
                                  </Typography>
                                }
                                {emergencyContactView &&
                                  <Typography variant="body2" gutterBottom>
                                    :
                                  </Typography>
                                }
                                <Typography variant="body2" gutterBottom style={{ fontWeight: 'bold', marginBottom: '10px' }}>

                                </Typography>

                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box padding={2}>
                                {/* <Typography variant="body1" gutterBottom style={{ textTransform: 'uppercase' }}>
                                        {cvData?.fullName}
                                      </Typography> */}
                                <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                  {formatDateOfBirth(cvData?.dob)}

                                </Typography>
                                <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                  {cvData?.age + ' YEARS OLD'}
                                </Typography>
                                <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                  {cvData?.personalInfo?.nationality}
                                </Typography>
                                <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                  {cvData?.gender}
                                </Typography>
                                <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                  {cvData?.civilStatus}
                                </Typography>
                                <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                  {cvData?.availability}
                                </Typography>
                                {showDrivingLicense &&
                                  <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                    {cvData?.personalInfo?.drivingLicense || 'AVAILABLE'}
                                  </Typography>
                                }
                                <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                  {cvData?.personalInfo?.passport || 'AVAILABLE'}
                                </Typography>
                                {whatsappContactView &&
                                  <Typography variant="body2" gutterBottom style={{ textTransform: 'uppercase' }}>
                                    {cvData?.personalInfo?.contact || 'AVAILABLE'}
                                  </Typography>
                                }
                                {emergencyContactView &&
                                  <>
                                    <Typography variant="body2" gutterBottom style={{ fontWeight: 'bold', marginBottom: '10px', textTransform: 'uppercase' }}>
                                      <strong>{'1. ' + cvData?.personalInfo?.emergencyNumberOne}</strong>
                                    </Typography>
                                    <p style={{ marginBottom: '5px', textTransform: 'uppercase' }}>
                                      {cvData?.personalInfo?.emergencyNumberOneName + '(' + cvData?.personalInfo?.emergencyNumberOneRelation + ')'}
                                    </p>
                                    <Typography variant="body2" gutterBottom style={{ fontWeight: 'bold', marginBottom: '10px', textTransform: 'uppercase' }}>
                                      <strong>{'2. ' + cvData?.personalInfo?.emergencyNumberTwo}</strong>
                                    </Typography>
                                    <p style={{ marginBottom: '5px', textTransform: 'uppercase' }}>
                                      {cvData?.personalInfo?.emergencyNumberTwoName + '(' + cvData?.personalInfo?.emergencyNumberTwoRelation + ')'}
                                    </p>
                                  </>
                                }
                              </Box>
                            </Grid>

                          </Grid>
                        </Box>
                      </Grid>


                    </Grid>
                  </Box>
                </td>
              </tr>
            </tbody>

            <div>
              <Box sx={{ height: `${boxHeightBeforeCareer}px` }} />

            </div>
            {/* Summary */}
            <tbody>
              <td>
                <HeightBox height={20} />

                <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                  <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='right'
                    sx={{ backgroundColor: '#17375e', color: 'white', padding: '10px', opacity: 1 }}
                  >
                    <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                      <strong> SUMMARY OF CAREER </strong>
                    </Typography>
                  </Box>
                  <HeightBox height={10} />



                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Box padding={2}>
                            <Typography variant="body2" gutterBottom>
                              <strong>YEARS OF EXPERIENCE</strong>
                            </Typography>

                            {showItLiteracy &&
                              <Typography variant="body2" gutterBottom>
                                <strong>IT LITERACY</strong>
                              </Typography>
                            }

                            <Typography variant="body2" gutterBottom>
                              <strong>CURRENT LOCATION</strong>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              <strong>CURRENT SALARY PACKAGE</strong>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              <strong>EXPECTED SALARY</strong>
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              <strong>INTERESTED TO WORK IN {cvData?.personalInfo?.interestedToWork}</strong>
                            </Typography>

                          </Box>
                        </Grid>
                        <Grid item xs={1}>
                          <Box padding={2}>
                            <Typography variant="body2" gutterBottom>
                              :
                            </Typography>
                            {showItLiteracy &&
                              <Typography variant="body2" gutterBottom>
                                :
                              </Typography>
                            }
                            <Typography variant="body2" gutterBottom>
                              :
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              :
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              :
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              :
                            </Typography>

                          </Box>
                        </Grid>
                        <Grid item xs={5}>
                          <Box padding={2}>
                            <Typography variant="body2" gutterBottom>
                              {cvData?.personalInfo?.totalYearsOfExperience && cvData.personalInfo.totalYearsOfExperience.toString().toUpperCase() + ' YEARS'}
                            </Typography>
                            {showItLiteracy &&
                              <Typography variant="body2" gutterBottom>
                                {cvData?.personalInfo?.itLiteracy && cvData.personalInfo.itLiteracy.toString().toUpperCase()}
                              </Typography>
                            }
                            <Typography variant="body2" gutterBottom>
                              {cvData?.personalInfo?.currentLocation && cvData.personalInfo.currentLocation.toString().toUpperCase()}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              {cvData?.personalInfo?.currentSalaryPackage && (
                                <span>
                                  {cvData.personalInfo.currentSalaryPackageCurrency}{' '}
                                  {Number(cvData.personalInfo.currentSalaryPackage).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </span>
                              )}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              {cvData?.personalInfo?.expectedSalaryPackage && (
                                <span>
                                  {cvData?.personalInfo?.expectedSalaryPackageCurrency}{' '}
                                  {Number(cvData.personalInfo.expectedSalaryPackage).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </span>
                              )}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              YES
                            </Typography>
                          </Box>


                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>
                    <HeightBox height={10} />
                    {showProfessionalQualifications &&
                      <Grid item xs={12} style={{ pageBreakInside: 'avoid' }}>

                        <Box padding={2}>
                          <Grid item xs={12}>
                            <Typography variant="body1" gutterBottom>
                              <strong>PROFESSIONAL QUALIFICATIONS SUMMARY:</strong>
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="body1" gutterBottom>
                              {cvData?.personalInfo?.professionalSummary}
                            </Typography>
                          </Grid>
                        </Box>
                      </Grid>
                    }

                  </Grid>


                </Box>
              </td>
            </tbody>
            {/* {emergencyContactView && whatsappContactView && (
              <HeightBox heightBox={40}/>
            )
            } */}

            <div>
              <Box sx={{ height: `${boxHeightCareer}px` }} />

            </div>

            {/* education */}
            {showEducationalQualifications && (
              <tbody>

                <td>
                  <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      alignItems='right'
                      sx={{ backgroundColor: ' #17375e ', color: 'white', padding: '10px', opacity: 1 }}
                    >
                      <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                        <strong>EDUCATIONAL QUALIFICATIONS</strong>
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" flexDirection="row">
                    <Box>
                      <td>
                        <List>
                          {cvData?.educationalQualification?.map((qualification) => (
                            <ListItem key={qualification.title}>
                              <ListItemText
                                primary={qualification.examination}
                                secondary={qualification.stream === undefined ? `( ${qualification.year} )` : qualification.stream
                                  + " (" + qualification.year + ")"}
                                className={ListItemTextStyle}
                              />
                            </ListItem>
                          ))}
                        </List>
                        <Box>
                          <div dangerouslySetInnerHTML={{
                            __html:
                              cvData?.otherQualification?.educationalQualification
                          }}></div>
                        </Box>
                      </td>
                    </Box>
                  </Box>

                </td>


              </tbody>
            )
            }

            {/* Higher Education */}
            {
              showHigherEducationalQualifications ?
                <tbody>
                  <td>
                    <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                      <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='right'
                        sx={{ backgroundColor: ' #17375e ', color: 'white', padding: '10px', opacity: 1 }}
                      >
                        <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                          HIGHER EDUCATIONAL QUALIFICATIONS
                        </Typography>
                      </Box>
                    </Box>

                    <Box display="flex" flexDirection="row">
                      <Box>
                        <td>
                          <List>
                            {cvData?.higherEducationalQualification?.map((qualification) => (
                              <ListItem key={qualification.title}>
                                <ListItemText
                                  primary={qualification.prefix}
                                  // primary={qualification.prefix + ' in ' + qualification.course}
                                  secondary={qualification.university + ", " + qualification.location + " (" + qualification.start + " - " + qualification.complete + ")"}
                                  className={ListItemTextStyle}
                                />
                              </ListItem>
                            ))}
                          </List>
                          <Box>
                            <div dangerouslySetInnerHTML={{
                              __html:
                                cvData?.otherQualification?.higherEducationalQualification
                            }}></div>
                          </Box>
                        </td>
                      </Box>
                    </Box>
                  </td>
                </tbody>
                : null
            }



            <div>
              <Box sx={{ height: `${boxAfterHigherEducationHeight}px` }} />

            </div>
            {/* {cvData?.higherEducationalQualification?.length===1
             && <HeightBox height={10} />
             } */}
            {/* professionalQualifications */}
            <tbody>

              {showProfessionalQualifications &&
                <td >
                  {/* <td style={{ pageBreakInside: 'avoid' }}> */}

                  <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      alignItems='right'
                      sx={{ backgroundColor: ' #17375e ', color: 'white', padding: '10px', opacity: 1 }}
                    >
                      <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                        <strong> PROFESSIONAL QUALIFICATIONS </strong>
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" flexDirection="row">
                    <Box>
                      <td>
                        <List>
                          {cvData?.professionalQualification?.map((qualification) => (
                            <ListItem key={qualification.title}>
                              <ListItemText
                                primary={qualification.course}
                                secondary={qualification.university + " , " + qualification.location + " " + " (" + qualification.start + " - " + qualification.complete + ")"}
                                className={ListItemTextStyle}
                              />
                            </ListItem>
                          ))}
                        </List>

                        <Box>
                          <div dangerouslySetInnerHTML={{
                            __html:
                              cvData?.otherQualification?.professionalQualification
                          }}></div>
                        </Box>
                      </td>
                    </Box>
                  </Box>

                </td>

              }

            </tbody>

            {/* professionalQualifications */}
            <tbody>


              {showProfessionalMemberships &&

                <td>
                  <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      alignItems='right'
                      sx={{ backgroundColor: ' #17375e ', color: 'white', padding: '10px', opacity: 1 }}
                    >
                      <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                        <strong> PROFESSIONAL MEMBERSHIPS </strong>
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" flexDirection="row">
                    <Box>
                      <td>
                        <List>
                          {cvData?.professionalMembership?.map((qualification) => (
                            <ListItem key={qualification.title}>
                              <ListItemText
                                primary={qualification.membership}
                                secondary={qualification.institute + " (Membership Number - " + qualification.number + ")"}
                                className={ListItemTextStyle}
                              />
                            </ListItem>
                          ))}
                        </List>
                        <Box style={{ paddingLeft: 16 }}>
                          <div dangerouslySetInnerHTML={{
                            __html:
                              cvData?.otherQualification?.professionalMembership
                          }}></div>
                        </Box>
                      </td>
                    </Box>
                  </Box>

                </td>
              }
            </tbody>
            {/* workExperience */}

            <div>
              <Box sx={{ height: `${boxHeightBeforeWorkExperience}px` }} />

            </div>

            <tbody>

              <td>
                <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                  <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='right'
                    sx={{ backgroundColor: ' #17375e ', color: 'white', padding: '10px', opacity: 1 }}
                  >
                    <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                      <strong>WORK EXPERIENCE</strong>
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" flexDirection="row">
                  <Box>
                    <List>
                      {cvData?.workExperience?.map((qualification) => (

                        <ListItem style={{ pageBreakInside: workExperienceBreak ? 'avoid' : 'auto' }} key={qualification.title}>
                          <ListItemText
                            primary={qualification.designation + " - " + qualification.company + ", " + qualification.location + " (" + qualification.start + " - " + qualification.complete + ")"}
                            secondary={
                              <div dangerouslySetInnerHTML={{
                                __html:
                                  qualification.description
                              }}></div>
                            }
                            className={ListItemTextStyle}
                          />


                        </ListItem>

                      ))}
                    </List>
                    <Box>

                    </Box>
                  </Box>
                </Box>

              </td>
            </tbody>

            <Box sx={{ height: `${boxBeforeSkills}px` }} />
            {/* Skills */}
            <tbody>
              <td >
                <HeightBox height={5} />

                <Box sx={{ fontSize: '16px', fontFamily: 'Arial, sans-serif' }}>
                  <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='right'
                    sx={{ backgroundColor: ' #17375e ', color: 'white', padding: '10px', opacity: 1 }}
                  >
                    <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
                      <strong>SKILLS</strong>
                    </Typography>
                  </Box>
                  <HeightBox height={10} />


                  <Grid container spacing={2}>
                    <HeightBox height={10} />

                    <Grid item xs={6} style={{ paddingLeft: '40px' }}>
                      <Typography variant="body1" gutterBottom>
                        <strong>SOFT SKILLS:</strong>
                      </Typography>
                      <div dangerouslySetInnerHTML={{ __html: cvData?.otherQualification?.softSkills }}></div>
                    </Grid>
                    <Grid item xs={6}>
                      {showHardSkills &&
                        <>
                          <Typography variant="body1" gutterBottom>
                            <strong>HARD SKILLS:</strong>
                          </Typography>

                          <div dangerouslySetInnerHTML={{ __html: cvData?.otherQualification?.hardSkills }}></div>
                        </>
                      }
                    </Grid>

                  </Grid>

                </Box>
              </td>
            </tbody>

            {/* Images */}
            <div>
              <Box sx={{ height: `${boxAfterSkills}px` }} />

            </div>
            <tfoot>
              <Divider />
            </tfoot>

            {contentHeight >= a4SheetHeight && renderHorizontalLines()}
          </table>
          <div>
            <div>
              {selectedURLs.map((url) => (
                <div key={url}>
                  {console.log(url)}
                  <Document file={url} onLoadSuccess={(event) => onDocumentLoadSuccess(url, event)}>
                    {Array.from(new Array(numPagesMap[url] || 0), (_, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} width={750} />
                    ))}
                  </Document>
                </div>
              ))}



            </div>
          </div>


        </div>
        <div style={{ padding: '10px' }}>

          <FileList nic={cvData.nic} />
          <HeightBox height={20} />
          <Button variant='contained' style={{ marginRight: '10px' }} onClick={handlePrint}>Print Profile</Button>
          <Button variant='contained' style={{ marginRight: '10px' }} onClick={() => dispatch(setSelectedURLs([]))}>Clear Attachments</Button>
          {/* <Button variant="contained" color="primary" onClick={()=>sendData} >
      Update Profile
      </Button> */}
          <HeightBox height={200} />
          {/* <Button onClick={()=>setShowIt(!showIt)}>Show/Hide Attachments</Button> */}

          {/* {showIt && <PageViewer componentRef={componentRef} />}   */}

        </div>
      </>
    </ThemeProvider>
  );
};

export default UserProfileContainer;
